import { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../services/api";

export default function Login() {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  const login = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(
        `${BASE_URL}/admin/login`,
        { email, password }
      );

      localStorage.setItem("adminToken", res.data.token);
      window.location.href = "/";

    } catch (err) {
      setError(err.response?.data?.message ?? "Identifiants invalides");
    }

    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0B3C5D",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 20,
        padding: "40px 36px",
        width: 360,
        boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
      }}>

        {/* Logo / Icône */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{
            width: 80, height: 80,
            borderRadius: "50%",
            background: "#0B3C5D",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 14,
            boxShadow: "0 4px 20px rgba(11,60,93,0.3)",
          }}>
            <img src="/logo.png" alt="Dieulsima" style={{ width: 48, height: 48, objectFit: "contain" }} />
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, color: "#0B3C5D", letterSpacing: 1 }}>
            DIEULSIMA
          </div>
          <div style={{ fontSize: 13, color: "#aaa", marginTop: 4 }}>
            Dashboard Administrateur
          </div>
        </div>

        {/* Erreur */}
        {error && (
          <div style={{
            background: "#FCEBEB", color: "#A32D2D",
            padding: "10px 14px", borderRadius: 8,
            fontSize: 13, marginBottom: 16,
            border: "0.5px solid #F5C6C6",
          }}>
            ❌ {error}
          </div>
        )}

        {/* Formulaire */}
        <form onSubmit={login}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, color: "#888", display: "block", marginBottom: 6 }}>
              Email
            </label>
            <input
              type="email"
              placeholder="admin@dieulsima.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: "100%", padding: "11px 14px",
                borderRadius: 8, fontSize: 14,
                border: "0.5px solid #ddd",
                outline: "none", color: "#0B3C5D",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 13, color: "#888", display: "block", marginBottom: 6 }}>
              Mot de passe
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={{
                width: "100%", padding: "11px 14px",
                borderRadius: 8, fontSize: 14,
                border: "0.5px solid #ddd",
                outline: "none", color: "#0B3C5D",
                boxSizing: "border-box",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%", padding: "13px",
              borderRadius: 8, border: "none",
              background: loading ? "#ccc" : "#FFA500",
              color: "#fff", fontSize: 15,
              fontWeight: 600, cursor: loading ? "default" : "pointer",
              letterSpacing: 0.5,
            }}
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: "#ccc" }}>
          Dieulsima © {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
}